export { DMS_MODULE } from '../constants';
export const NAME = 'WmsFinalInspection';
export const API_NAME = 'WmsFinalInspection';
export const CRUMB_LABEL_KEY = 'WmsFinalInspection';
